<div class="modal-header">
        <h4 class="modal-title fw-bold">
            {{previewCross.cross}}
        </h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
                (click)="close()">
        </button>
</div>
<div class="modal-body">
    <div class="row">
        <span><i> {{ 'design-crosses.existing.crosses.modal.message' | translate: { param: previewCross.cross } }} </i></span>
    </div>
    <div>
        <div class="table-responsive" *ngIf="currentPagePreviewList">
            <div class="custom-scroll-style" style="max-height: 300px; y-overflow: auto;">
                <table id="existing-crosses-table" class="table table-striped table-bordered table-curved table-fixed">
                    <thead class="sticky-header">
                    <tr>
                        <th scope="col">
                            <span jhiTranslate="design-crosses.existing.crosses.modal.gid">GID</span>
                        </th>
                        <th scope="col">
                            <span jhiTranslate="design-crosses.existing.crosses.modal.designation">DESIGNATION</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody *ngIf="currentPagePreviewList.length else nodata">
                    <tr *ngFor="let germplasm of currentPagePreviewList">
                        <td><a class="link" (click)="openGermplasmDetailsInTab(germplasm.gid)">{{germplasm.gid}}</a></td>
                        <td>{{germplasm.preferredName}}</td>
                    </tr>
                    </tbody>
                </table>
                <ng-template #nodata>
                    <tbody>
                    <tr>
                        <td colspan="8" jhiTranslate="no.data"></td>
                    </tr>
                    </tbody>
                </ng-template>
            </div>

        </div>

        <div *ngIf="currentPagePreviewList && currentPagePreviewList.length">
            <div class="row">
                <div class="col">
                    <div class="pagination-container">
                        <div class="pagination-box pagination-box-left">
                            <div>
                                <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                            </div>
                        </div>
                        <div class="pagination-box">
                            <ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
                                            [maxSize]="3" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
                        </div>
                        <div class="pagination-box pagination-box-right">
                            <div class="d-flex align-items-center">
                                <label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
                                <select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading"
                                        (change)="resetTable();" style="width:95px">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-primary" (click)="close()">
        Close
    </button>
</div>
